var map = {
	"./a_todos_um_bom_natal.mp3": "9202",
	"./amogus.mp3": "7ba7",
	"./anuncio_lol.mp3": "16ca",
	"./astronaut_ocean.mp3": "89d2",
	"./bossac.mp3": "aac3",
	"./burgir.mp3": "e5e7",
	"./can_you_feel_my_heart.mp3": "fc3c",
	"./careless_whisper.mp3": "d643",
	"./cyberpunk.mp3": "7b31",
	"./discord.mp3": "ffdc",
	"./hallelujah.mp3": "d3ac",
	"./ihh_ca_burro.mp3": "3911",
	"./john_cena.mp3": "4c47",
	"./jojo_ayayay.mp3": "2ba7",
	"./mlg_airhorn.mp3": "2beb",
	"./nao_e_nao.mp3": "31ca",
	"./never_gonna_give_you_up.mp3": "7935",
	"./olha_tanta_luz.mp3": "a138",
	"./pingo_doce.mp3": "8d54",
	"./polozhenie.mp3": "0ec1",
	"./shape_of_you.mp3": "c5aa",
	"./shooting_stars.mp3": "4065",
	"./super_idol.mp3": "2bc3",
	"./um_volto_ja.mp3": "9d7f",
	"./vine_boom.mp3": "3122",
	"./yeah_baby.mp3": "4556"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5fa7";